// TecnicosTabs — sub-navegação compartilhada entre páginas do "Técnicos"
// (lista + escalas). Renderizar no topo de cada página da seção.
import { NavLink } from 'react-router-dom';

export default function TecnicosTabs() {
  return (
    <div className="tecnicos-tabs">
      <NavLink to="/tecnicos" end className={({isActive}) => 'tab-link' + (isActive ? ' active' : '')}>
        👥 Equipe
      </NavLink>
      <NavLink to="/tecnicos/escalas" className={({isActive}) => 'tab-link' + (isActive ? ' active' : '')}>
        📋 Escalas & plantões
      </NavLink>
    </div>
  );
}
